import {NavigationItem} from '../navigation-item';
import {ElementRef} from '@angular/core';

export class NavigationState {
  navItemSource: Array<Array<Array<NavigationItem>>>;
  currentPageActiveComponent: string;
  currentPageComponents: any[];
  activeX: number;
  activeY: number;
  vhValue: number;
  scrollState: string;
  infiniteScrolling = false;
  currentPageElement: ElementRef;

  constructor() {
    this.navItemSource = Array<Array<Array<NavigationItem>>>();
    this.currentPageActiveComponent = '';
    this.currentPageComponents = [];
    this.vhValue = 0;
    this.scrollState = 'scrollState1';
  }

}
